import { SubscriptionList } from "./List";
import { EditForm } from "./EditForm";

export default {
  List: SubscriptionList,
  EditForm,
};
